import { atom } from "jotai";

export const tuningPromptsAtom = atom<string[]>([]);
tuningPromptsAtom.debugLabel = "tuningPromptsAtom";
